module.exports = __webpack_public_path__ + "static/media/settings.fd34151d.svg";